import { Skeleton } from "@/components/ui/skeleton";
interface ProductCardLoaderProps {
  uniqueKey?: string;
}
const ProductCardLoader: React.FC<ProductCardLoaderProps> = ({
  uniqueKey
}) => <div className="w-full h-auto" data-sentry-component="ProductCardLoader" data-sentry-source-file="product-card-loader.tsx">
    <div className="aspect-[334/430] rounded-md overflow-hidden">
      <Skeleton className="w-full h-full" data-sentry-element="Skeleton" data-sentry-source-file="product-card-loader.tsx" />
    </div>
    <div className="mt-6 space-y-3 px-4">
      <Skeleton className="h-2 w-1/2 rounded-sm" data-sentry-element="Skeleton" data-sentry-source-file="product-card-loader.tsx" />
      <Skeleton className="h-1.5 w-5/6 rounded-sm" data-sentry-element="Skeleton" data-sentry-source-file="product-card-loader.tsx" />
      <Skeleton className="h-2 w-1/4 rounded-sm" data-sentry-element="Skeleton" data-sentry-source-file="product-card-loader.tsx" />
    </div>
  </div>;
export default ProductCardLoader;